"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Video = void 0;
var Video;
(function (Video) {
    Video.type = 'video';
    Video.videoEnum = Object.freeze({
        NOTREADY: 'NOTREADY',
        UNSTARTED: 'UNSTARTED',
        PLAY: 'PLAY',
        PAUSE: 'PAUSE',
        BUFFERING: 'BUFFERING',
        STOPPED: 'STOPPED',
        ENDED: 'ENDED',
    });
    function isInteractiveVideo(pin) {
        return Boolean(isVideo(pin) && pin.settings.videoItems?.length);
    }
    Video.isInteractiveVideo = isInteractiveVideo;
    function isVideo(pin) {
        return Boolean(pin.type === 'VIDEO');
    }
    Video.isVideo = isVideo;
    function videoIdForPin(pin) {
        // return isVideo(pin) ? pin.item.custom.id : undefined;
        // TODO: Verify this is the correct translation of above
        return isVideo(pin) ? pin.parentPinId : undefined;
    }
    Video.videoIdForPin = videoIdForPin;
    function youtubeEmbedUrlForId(id) {
        if (!id)
            return undefined;
        return `//youtube-nocookie.com/embed/${id}`;
    }
    Video.youtubeEmbedUrlForId = youtubeEmbedUrlForId;
    function vimeoEmbedUrlForId(id, isTrackingAllowed) {
        if (!id)
            return undefined;
        return isTrackingAllowed ? `https://player.vimeo.com/video/${id}` : `https://player.vimeo.com/video/${id}?dnt=1`;
    }
    Video.vimeoEmbedUrlForId = vimeoEmbedUrlForId;
    function videoEmbedUrlForPin(pin, isTrackingAllowed) {
        if (pin.type !== 'VIDEO' || !pin.settings.video)
            return undefined;
        const { video } = pin.settings;
        switch (video.type) {
            case 'YOUTUBE':
                return youtubeEmbedUrlForId(video.id);
            case 'VIMEO':
                return vimeoEmbedUrlForId(video.id, isTrackingAllowed);
            // TODO: don't we miss schooltv here? or can't this be embedded?
            default:
                return undefined;
        }
    }
    Video.videoEmbedUrlForPin = videoEmbedUrlForPin;
    function sortVideoItems(items, lessonPins) {
        return items.sort((a, b) => {
            if (b.end) {
                return a.time - b.end;
            }
            if (a.end) {
                return a.end - b.time;
            }
            return a.time - b.time;
        });
    }
    Video.sortVideoItems = sortVideoItems;
})(Video || (exports.Video = Video = {}));
//# sourceMappingURL=Video.js.map